/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { useDatasourceAnalyticsEvents } from '../../../../analytics';
import { cancelButtonMessages } from './messages';
export var CancelButton = function CancelButton(_ref) {
  var getAnalyticsPayload = _ref.getAnalyticsPayload,
    onCancel = _ref.onCancel,
    testId = _ref.testId;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  var onCancelClick = useCallback(function () {
    fireEvent('ui.button.clicked.cancel', getAnalyticsPayload());
    onCancel();
  }, [getAnalyticsPayload, fireEvent, onCancel]);
  return jsx(Button, {
    appearance: "default",
    onClick: onCancelClick,
    testId: testId
  }, jsx(FormattedMessage, cancelButtonMessages.cancelButtonText));
};